export const getCustomerErrorTab = (
  errors: any
): 'general' | 'pickup' | null => {
  if (!errors || typeof errors !== 'object') return null;

  const generalTabReqKey = [
    'customerInfo',
    'customerAddress',
    'customerContact',
  ];
  const pickupTabReqKey = ['pickupAddresses'];

  const keys = Object.keys(errors);

  if (keys.length === 0) return null;

  const firstKey = keys[0];

  if (generalTabReqKey.includes(firstKey)) return 'general';
  if (pickupTabReqKey.includes(firstKey)) return 'pickup';

  return null;
};
